var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIndex = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  fillRule: "evenodd",
  clipRule: "evenodd",
  viewBox: "2.75 2.75 12.5 12.5",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.5 7h-3v4h3V7Zm4 1H10v1h2.5V8ZM10 10h2.5v1H10v-1Zm5.25-5.5a.75.75 0 0 0-.75-.75h-11a.75.75 0 0 0-.75.75v9c0 .414.336.75.75.75h11a.75.75 0 0 0 .75-.75v-9Zm-11 .75h9.5v7.5h-9.5v-7.5Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIndex);
export default ForwardRef;